import styled from '@emotion/styled';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

import Image, { ImageProps } from '../Image';

export interface BannerData extends ImageProps {
  bannerId?: string;
  link: string;
  external?: boolean;
  disabled?: boolean;
}

const StyledAnchor = styled.a<
  Pick<BannerData, 'width' | 'height' | 'disabled'>
>(({ width, height, disabled }) =>
  mq({
    display: 'inline-block',
    borderRadius: defaultTheme.border.radius.s,
    zIndex: 1,
    position: 'relative',
    overflow: 'hidden',
    verticalAlign: 'bottom',
    pointerEvents: disabled ? 'none' : 'auto',
    ...hoverOpacity,
    '& > img': {
      width,
      height,
    },
  }),
);

const StyledLink = StyledAnchor.withComponent(Link);

const Banner: React.FC<BannerData> = ({
  srcSet,
  mediaSet,
  alt,
  link,
  external,
  disabled,
  width,
  height,
  aspectRatio,
  overflow,
}) => {
  return external ? (
    <StyledAnchor
      href={link}
      target="_blank"
      rel="noreferrer"
      width={width}
      height={height}
      disabled={disabled}
    >
      <Image
        srcSet={srcSet}
        mediaSet={mediaSet}
        alt={alt}
        width={width}
        height={height}
        aspectRatio={aspectRatio}
        overflow={overflow}
      />
    </StyledAnchor>
  ) : (
    <StyledLink to={link} width={width} height={height} disabled={disabled}>
      <Image
        srcSet={srcSet}
        mediaSet={mediaSet}
        alt={alt}
        width={width}
        height={height}
        aspectRatio={aspectRatio}
        overflow={overflow}
      />
    </StyledLink>
  );
};

export default Banner;
